import { RootState } from '@/core/redux/store';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { staticUrl } from '@/core/utils';
import { useCore } from '@/core/hooks/useCore';

interface HeaderProps {
  className?: string;
}

export const Header: React.FC<HeaderProps> = ({ className = '' }) => {
  const { sessionData } = useSelector((state: RootState) => state.auth.main);
  const { gotoPtEApp } = useCore();
  const clientName = sessionData?.Client?.ClientName || 'PtE';
  const clientLogo = sessionData?.Client?.LogoUrl || '';
  const userAvatarUrl = sessionData?.User?.AvatarUrl || '';
  const userShortName = useMemo(() => {
    if (!sessionData?.User?.FirstName && !sessionData?.User?.LastName) {
      return '';
    }
    let shortName = '';
    if (sessionData?.User?.FirstName) {
      shortName += sessionData?.User?.FirstName.charAt(0);
    }
    if (sessionData?.User?.LastName) {
      shortName += sessionData?.User?.LastName.charAt(0);
    }
    return shortName;
  }, [sessionData?.User?.FirstName, sessionData?.User?.LastName]);

  if (!sessionData || !sessionData.User || !sessionData.Client) {
    return null;
  }

  return (
    <header
      className={`bg-container-primary ${className} min-h-12 sm:min-h-16 h-12 sm:h-16 border-b gray-scale-50 shadow-md sticky top-0 z-50 header-safe`}
    >
      <div className='max-w-12xl h-12 sm:h-16 w-full mx-auto px-3 flex justify-between items-center'>
        <div>
          <div
            className='items-center rounded-full p-1 max-h-10 h-10 w-10 border border-[#e8e8ed] cursor-pointer flex sm:hidden '
            onClick={() => gotoPtEApp()}
          >
            <img
              src={sessionData.Client.LogoUrl}
              alt='PtE Logo'
              className='min-h-8 w-8 h-8 rounded-full shadow-sm object-cover shrink-0 aspect-square'
            />
          </div>
          <img
            src={staticUrl('/images/pteverywhere-logo.png')}
            alt='User Profile Picture'
            className='cursor-pointer min-h-[32px] max-h-[32px] hidden sm:flex object-contain shrink-0'
            onClick={() => gotoPtEApp()}
          />
        </div>
        <div
          className='items-center justify-start cursor-pointer block sm:hidden'
          onClick={() => gotoPtEApp()}
        >
          <img
            src={staticUrl('/images/pteverywhere-logo.png')}
            alt='User Profile Picture'
            className='w-full min-h-8 max-h-8 object-contain shrink-0'
          />
        </div>
        <div className='flex items-center space-x-0 sm:space-x-4'>
          <div className='items-center rounded-full p-1 max-h-10 h-10 w-10 sm:w-auto border border-gray hidden sm:flex'>
            <img
              src={clientLogo}
              alt='User Profile Picture'
              className='min-h-8 w-8 h-8 rounded-full shadow-sm object-cover shrink-0 aspect-square'
            />
            <span className='text-sm font-semibold pl-2'>{clientName}</span>
          </div>
          <div className='hidden sm:block h-8 w-px bg-gray-300'></div>
          <div className='flex items-center rounded-full p-1 max-h-10 h-10 w-10 cursor-pointer border border-[#e8e8ed]'>
            {userAvatarUrl ? (
              <img
                src={userAvatarUrl}
                alt='User Profile Picture'
                className='min-h-8 w-8 h-8 rounded-full shadow-sm object-cover shrink-0 aspect-square'
              />
            ) : (
              <span className='w-8 h-8 rounded-full shadow-sm text-sm font-semibold flex items-center justify-center bg-primary-default text-white'>
                {userShortName}
              </span>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
